import { Locale } from '@enmon/commons/lib/shared';
import { atom } from 'recoil';

export const localeState = atom({
  key: 'locale',
  // NOTE: app uses czech date and number formats
  default: Locale.CS,
});
